import { SET_MESSAGE, CLEAR_MESSAGE, TOGGLE_CONTACTUS } from "../Actions/Types";


const initialState = {};

const Message = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_MESSAGE:
      return { message: payload };
    case CLEAR_MESSAGE:
      return { message: "" };
    case TOGGLE_CONTACTUS:
      console.log(payload)

      return {
        open : payload
      };
    default:
      return state;
  }
}

export default Message;
